function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 11px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  margin-right: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-image: url(", ");\n  background-repeat: no-repeat;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import tooltip from "../../../assets/icons/tooltip-small.svg";
import styled from "../../../theme";
import { CheckboxContainer } from "../Checkbox.styles";
export var TooltipIconSmall = styled.div(_templateObject(), function (props) {
  return props.theme.variables.icons.size.medium;
}, function (props) {
  return props.theme.variables.icons.size.medium;
}, tooltip);
export var TooltipCheckboxContainer = styled(CheckboxContainer)(_templateObject2());
export var TooltipCheckboxLabel = styled.div(_templateObject3());
export var TooltipCheckboxTooltip = styled.div(_templateObject4());
export var TooltipCheckboxTooltipBox = styled.div(_templateObject5());